@if ({ shouldDisplayApplePayCTA: shouldDisplayApplePayCTA$ | async, shouldDisplayNotifyMeCTA: shouldDisplayNotifyMeCTA$
| async, shouldDisplayRegisterYourInterestCTA: shouldDisplayRegisterYourInterestCTA$ | async, shouldDisplayAddToCartCTA:
shouldDisplayAddToCartCTA$ | async, productError: productError$ | async, isMobile: isMobile$ | async }; as
purchaseButtonInfo) { @if (product.stock?.retail && !product.stock?.ecom) {
<div class="call-to-action-container disclaimer" [class.transparent-background]="transparentBackground">
    <!-- There is ecom stock and bouton enabled-->
    <!-- Else, normal message -->
    <h-message-block [showBackground]="false" [messageIsCentered]="true" [type]="'info'">
        @if (product.size === 'SANS_TAILLE' || product.size === undefined) {
        <ng-container i18n="@@page-hermes-product-locator-available-in-store-only-message">
            This product is only available in store
        </ng-container>
        } @else {

        <ng-container i18n="@@hermes-availability.size-store-only"> This size is only available in store </ng-container>

        }
        <!-- If there is size variation, special message  -->
    </h-message-block>
</div>
} @if (addToCartButtonIsDisplayed) { @if (!inSticky || purchaseButtonInfo.shouldDisplayNotifyMeCTA ||
purchaseButtonInfo.shouldDisplayRegisterYourInterestCTA) {

<ng-container *ngTemplateOutlet="buttonsPurchase"></ng-container>

} @else {

<h-sticky-wrapper>
    <ng-container *ngTemplateOutlet="buttonsPurchase"></ng-container>
</h-sticky-wrapper>

} }

<ng-template #buttonsPurchase>
    <div
        class="call-to-action-container"
        [class.border-block-button]="border"
        [class.display-out-of-stock]="
            purchaseButtonInfo.shouldDisplayNotifyMeCTA || purchaseButtonInfo.shouldDisplayRegisterYourInterestCTA
        "
        [class.transparent-background]="transparentBackground">
        @if (purchaseButtonInfo.productError && purchaseButtonInfo.productError.enabled) {
        <h-message-block
            [type]="purchaseButtonInfo.productError.type"
            [showBackground]="purchaseButtonInfo.productError.showBackground"
            [messageIsCentered]="true"
            [class.no-margin]="
                hideButtonsOnError ||
                purchaseButtonInfo.shouldDisplayNotifyMeCTA ||
                purchaseButtonInfo.shouldDisplayRegisterYourInterestCTA
            ">
            {{ purchaseButtonInfo.productError.translation }}
        </h-message-block>
        } @if (!hideButtonsOnError || !(purchaseButtonInfo.productError && purchaseButtonInfo.productError.enabled)) {

        <div
            class="actions buttons-position-{{ buttonsPosition }}"
            [class.transparent-background]="transparentBackground"
            [class.has-apple-pay-button]="purchaseButtonInfo.shouldDisplayApplePayCTA">
            @if (purchaseButtonInfo.isMobile || buttonsPosition === 'row') {

            <ng-container *ngTemplateOutlet="applePayButton"></ng-container>
            <ng-container *ngTemplateOutlet="addToCartButton"></ng-container>

            } @else {

            <ng-container *ngTemplateOutlet="addToCartButton"></ng-container>
            <ng-container *ngTemplateOutlet="applePayButton"></ng-container>

            }
        </div>

        <ng-template #applePayButton>
            <!-- APPLE PAY BUTTON-->
            @if (purchaseButtonInfo.shouldDisplayApplePayCTA) {
            <h-call-to-action-apple-pay
                class="apple-pay-button flex-button"
                [size]="purchaseButtonInfo.isMobile ? 'small' : buttonsPosition === 'row' ? 'auto' : 'large'"
                [positions]="positions"
                [isDisabled]="(addToCartButtonEnabled$ | async) === false"
                [product]="product"
                [isProductEngraving]="isProductEngraving"
                [processingChannel]="processingChannelProduct">
            </h-call-to-action-apple-pay>
            }
        </ng-template>

        <ng-template #addToCartButton>
            <!-- ADD TO CART BUTTON-->
            @if (purchaseButtonInfo.shouldDisplayAddToCartCTA) {
            <h-call-to-action-add-to-cart
                class="add-to-cart-button"
                [size]="
                    buttonsPosition === 'row' && !purchaseButtonInfo.isMobile
                        ? 'auto'
                        : !purchaseButtonInfo.shouldDisplayApplePayCTA
                        ? 'medium'
                        : purchaseButtonInfo.isMobile
                        ? 'small'
                        : 'large'
                "
                [addToCartError]="purchaseButtonInfo.productError!"
                [positions]="positions"
                (addToCart)="addToCart.emit()">
            </h-call-to-action-add-to-cart>
            }
        </ng-template>

        }
    </div>
</ng-template>
<!-- NOTIFY ME BUTTON-->
@if (purchaseButtonInfo.shouldDisplayNotifyMeCTA) {
<h-call-to-action-notify-me #backInStockNotifyMeButton class="out-of-stock"></h-call-to-action-notify-me>
}
<!-- REGISTER YOUR INTEREST BUTTON-->
@if (purchaseButtonInfo.shouldDisplayRegisterYourInterestCTA) {
<h-call-to-action-register-your-interest
    #registerYourInterestButton
    class="out-of-stock"></h-call-to-action-register-your-interest>
} }
